import { html } from "htm/preact";
import { useState, useRef, useEffect } from "preact/hooks";
import "./styles/reactionWidget.css"

const ReactionWidget = ({ emojis = [], ...props }) => {

    let [ws, setWs] = useState(null);

    if (ws == null) {
        const skt = new WebSocket('wss:reaction-widget.swoogo-retrofit.tkevents.io')

        skt.onerror = skt.onopen = skt.onclose = null;

        skt.onopen = () => {
            console.log('Connection opened!');
        }

        skt.onclose = () => {
            setWs(null)
        }

        skt.onmessage = ({ data }) => {
            sendEmoji(data)
        }

        setWs(skt)
    }

    const sendEmoji = symbol => {
        setActiveEmojis(prev => [
            ...prev.filter(emoji => emoji.birthTime > new Date - 5000), {
                birthTime: new Date,
                symbol
            }])
    }


    const [activeEmojis, setActiveEmojis] = useState([])

    return <>
        <div style={{ width: "13.3%", height: "47.3%", left: "83.7%", top: "12.9%", position: "absolute", display: "flex", justifyContent: "space-evenly", zIndex: "10", alignItems: "end", flexDirection: "column", ...(props.style || {}) }}>
            <div style="position: relative; width: 100%; height: calc(100% - 12%); overflow: hidden">
                {activeEmojis.map(Emoji)}
            </div>
            <div style="width: 100%; height: 12%; display: flex; justify-content: space-around">
                {emojis.map(emoji => html`
                        <span class="emojiButton" role="img" style="" onclick=${() => { sendEmoji(emoji); ws.send(emoji); }}> ${emoji}</span>
                    `)}
            </div>
        </div>
    </>
}


/* Math functions used for driving animations */
const lerp = (min, max, q) => min + (max - min) * q
const unlerp = (min, max, val) => (val - min) / (max - min)
const eMap = (val, minIn, maxIn, minOut, maxOut, exp = 1) =>
    lerp(minOut, maxOut, unlerp(minIn, maxIn, val) ** exp)

const useInterval = (callback, delay, ...args) => {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current(...args);
            }
        }
        if (delay !== null && delay !== undefined) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}


export const Emoji = ({ birthTime, symbol }) => {
    // Config
    // Emojis die after 5 seconds, wobble horizontally at 0.5Hz, and move to 40% up the screen
    const
        deathTime = 5000,
        reciprocationInterval = 3000,
        deathHeight = 10

    // Derived stuff
    const
        timeNow = new Date(),
        age = timeNow - birthTime,
        startX = 0 + birthTime % 80

    // Fuel for the render stage
    const
        xPos = startX + 50 * Math.sin(birthTime / 1 + (age / reciprocationInterval)),
        yPos = eMap(age, 0, deathTime, 100, 60, 1)

    const [clock, setClock] = useState(new Date)

    useInterval(() => { setClock(new Date) }, 16.66)

    return html`<span role="img" class="reactionEmoji" style="top: ${yPos}%; left: ${xPos}%; opacity: ${age < 1000 ? 100 : eMap(age, 4000, 5000, 100, 0)}%">${symbol}<//>`
}
/*
const Emojis = () => {
    const sendEmoji = symbol => {setActiveEmojis([
        ...activeEmojis.filter(emoji => emoji.birthTime > new Date - 5000), {
        birthTime: new Date,
        symbol
    }]);
    
    }

    ws.onmessage = ({data} ) => {
        sendEmoji(data)
    }

    /* "shape" of an Emoji:
        {
            birthTime: Date()
            emoji: 😀 / 👍 etc
        }
    */

/* typedef: activeEmojis: emoji[] */
//const [activeEmojis, setActiveEmojis] = useState([])
// useInterval(sendEmoji, 500)
/*
    return <>
        {activeEmojis.map(Emoji)}
        <div style="width:13.3%; height:47.3%; left:83.7%; top:12.9%; position: absolute">
            {["💯","👍","🥱","⌛"].map(emoji =>html`
                <span class="emojiButton" role="img" style="" onclick=${() => {sendEmoji(emoji); ws.send(emoji);}}>${emoji} </span>
            `)}
            </div>
        </>
}
*/
export default ReactionWidget

//render(html`<${Emojis} />`, document.getElementById('root'))

//<main style="background: url('https://assets.swoogo.com/uploads/full/1172110-60b6313a0a801.jpg'); width: 100vw; height: 100vh; background-size: contain; background-position: top; background-repeat: no-repeat" id="root" />